import { render, staticRenderFns } from "./ResponsibleGamming.vue?vue&type=template&id=134f262a&scoped=true"
import script from "./ResponsibleGamming.vue?vue&type=script&lang=js"
export * from "./ResponsibleGamming.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleGamming.vue?vue&type=style&index=0&id=134f262a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f262a",
  null
  
)

export default component.exports